<div matSnackBarLabel>
  {{ data.label }}
</div>
<div matSnackBarActions>
  <button class="action" mat-button matSnackBarAction (click)="data.onAction()">{{ data.action }}</button>
</div>
